import { useEffect, useState } from "react";
import styled from "styled-components";

// Components
import CommonButton from "../../../components/common/CommonButton";

// Services
import { getSkillsTests } from "../services/tests";
import { useSelector } from "react-redux";

// Assets
import SkillsPana from "../../../assets/media/aden/skills-pana.png"
import Error from "../../../assets/media/aden/ticket-creation-error.png";

const SkillsTest = () => {

    const ondemand_id = useSelector((state) => state?.auth?.user?.ondemand_id);

    const [tests, setTests] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let isMounted = true;
        fetchData(isMounted);
        return () => {
            isMounted = false;
        }
    }, []);

    const fetchData = async (isMounted) => {
        setLoading(true);
        try {
            const data = await getSkillsTests(ondemand_id);
            if (isMounted) {
                setTests(data);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            console.info("Skills tests fetched successfully", tests);
            isMounted = false;
        }
    }

    const handleGoToTest = (id) => {
        window.open(`https://app.acropolislab.com/test/${id}`, '_blank');

    }

    return (
        <Container>
            <h1>¿Qué habilidad deseas explorar hoy?</h1>
            <CardsContainer>
                {
                    loading && (
                        <>
                            <SkillCardSkeleton />
                            <SkillCardSkeleton />
                            <SkillCardSkeleton />
                        </>
                    )
                }
                {
                    !!tests && tests?.map((test) => (
                        <SkillCard key={test?.id}>
                            <header>
                                <label>{test?.name}</label>
                            </header>
                            <img src={SkillsPana} alt="skills-pana" />
                            <CommonButton
                                label="Realizar test"
                                variant="filled"
                                onClick={() => handleGoToTest(test?.id)}
                            />
                        </SkillCard>
                    ))
                }
                {
                    (!tests && !loading) && (
                        <ErrorContainer>
                            <img src={Error} alt="error" width={400} />
                            <p>No posee test de conocimientos para realizar</p>
                        </ErrorContainer>
                    )
                }
            </CardsContainer>
        </Container>
    );
};

export default SkillsTest;

const Container = styled.div`
    width: calc(100% - 4rem);
    min-height: 70vh;
    height: 100%;
    background-color: #fff;
    border-radius: 30px;
    padding: 2rem;
    box-shadow: 0px 8px 24px -4px #18274B14, 0px 6px 12px -6px #18274B1F;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 2rem;

    h1 {
        font-size: 24px;
        font-weight: 700;
        color: #b31d15;
    }
`;

const CardsContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 2rem;
`

const SkillCardSkeleton = styled.div`
    height: 360px;
    width: 350px;
    border-radius: 20px;
    background-color: #f1f1f1;
    padding-bottom: 2rem;
`;

const SkillCard = styled.div`
    height: 360px;
    width: 350px;
    border-radius: 20px;
    border: 1px solid #b31d15;  
    background-color: #f1f1f1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2rem;

    header {
        height: 70px;
        width: 100%;
        border-bottom: 1px solid #b31d15;
        display: flex;
        justify-content: center;
        align-items: center;

        label {
            font-size: 20px;
            font-weight: 700;
            color: #b31d15;
            text-align: center;
        }
    }
`

const ErrorContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    border-radius: 20px;

    p {
        width: 100%;
        color: #b31d15;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
    }
`;